import { UPDATE_PROFILE_IMAGE, UPDATE_PROFILE_IMAGE_LINK, RESET_PROFILE_IMAGE } from './actions'
import { IProfileImage } from './contracts'

export const PROFILE_IMAGE_INITIAL_STATE: IProfileImage = {
  id: null,
  path: null,
  isDeleted: false,
  name: null,
  size: 0,
  mimetype: null,
  extension: null,
  type: null,
  content: null,
  sourceFile: null
}
export interface IHubIProfileImageStateAction {
  type: string
  payload: IProfileImage | string
}

export const HubProfileImageReducer = (
  state: IProfileImage = PROFILE_IMAGE_INITIAL_STATE,
  action: IHubIProfileImageStateAction
): IProfileImage => {
  switch (action.type) {
    case UPDATE_PROFILE_IMAGE:
      return {
        ...state,
        ...(action.payload as IProfileImage)
      }
    case UPDATE_PROFILE_IMAGE_LINK:
      return {
        ...state,
        path: action.payload as string
      }
    case RESET_PROFILE_IMAGE:
      return structuredClone(PROFILE_IMAGE_INITIAL_STATE)
    default:
      return state
  }
}
